import {createLogger} from 'redux-logger';
import {createStore, applyMiddleware} from 'redux';
import thunkMiddleware from 'redux-thunk';

const configureStore = (reducer) => {
    let appliedMiddleware = applyMiddleware(thunkMiddleware);

    if (process.env.NODE_ENV !== 'production') {
        const logger = createLogger({
            collapsed: true,
            diff: true,
        });
        appliedMiddleware = applyMiddleware(thunkMiddleware, logger);
    }
    const store = createStore(reducer, appliedMiddleware);

    return store;
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/utils/configureStore.js